import { getVariantDisplayQuantity } from './variant-display';
import { Product } from '../models/product.model';

export type CsvCell = string | number | boolean | null | undefined;

export const PRODUCT_EXPORT_HEADERS = [
  'Product ID',
  'Product Name',
  'Brand',
  'Categories',
  'Variant',
  'SKU',
  'MRP',
  'Product Status',
  'Variant Status',
  'Product Created At',
  'Product Updated At',
] as const;

function safeSpreadsheetText(value: CsvCell): string {
  if (typeof value === 'number') return Number.isFinite(value) ? String(value) : '';
  const text = String(value ?? '');
  let start = 0;
  while (start < text.length && (text.charCodeAt(start) <= 32 || /\s/.test(text[start]))) start++;
  return /^[=+\-@]/.test(text.slice(start)) ? `'${text}` : text;
}

export function escapeCsvCell(value: CsvCell): string {
  const text = safeSpreadsheetText(value);
  return `"${text.replace(/"/g, '""')}"`;
}

export function buildCsv(
  headers: readonly string[],
  rows: readonly (readonly CsvCell[])[]
): string {
  const lines = [headers, ...rows].map((row) =>
    row.map(escapeCsvCell).join(',')
  );
  return `\uFEFF${lines.join('\r\n')}`;
}

export function buildProductExportRows(products: readonly Product[]): CsvCell[][] {
  const rows: CsvCell[][] = [];
  for (const product of products) {
    const variants = product.variants?.length ? product.variants : [null];
    for (const variant of variants) {
      rows.push([
        product.id,
        product.name,
        product.brand?.name ?? '',
        product.categories?.map((category) => category.name).join(' | ') ?? '',
        getVariantDisplayQuantity(variant),
        variant?.sku ?? '',
        variant?.mrp ?? '',
        product.isActive ? 'Active' : 'Inactive',
        variant == null ? '' : variant.is_active ? 'Active' : 'Inactive',
        product.createdAt,
        product.updatedAt ?? '',
      ]);
    }
  }
  return rows;
}

export function downloadCsv(fileName: string, csv: string): void {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
}
